import React from 'react';
import spinner from 'assets/svg/spinner.svg';

type ButtonProps = {
    label: string;
    type?: 'submit' | 'reset' | 'button';
    variant?: 'primary' | 'secondary' | 'partner-primary' | 'partner-secondary';
    className?: string;
    disabled?: boolean;
    loading?: boolean;
    mode?: 'background';
    id?: string;
    onClick?:() => void;
}

const Button: React.FC<ButtonProps> = (props) => {
    const { type = 'button', variant = 'primary', className, disabled = false, loading = false, mode, id, label, ...otherProps } = props;
    const classNames = [ 'btn-biz', variant ];

    if (className) {
        classNames.push(className);
    }

    if (mode) {
        classNames.push(mode);
    }

    if (loading) {
        classNames.push('loading');
    }

    if (disabled) {
        classNames.push('disabled');
    }

    return (
        <button
            type={type}
            className={classNames.join(' ')}
            disabled={loading || disabled}
            {...otherProps}
            id={id || ''}
        >
            { label }
            { loading && (
                <div className="loading-icon">
                    <img src={spinner} />
                </div>
            ) }
        </button>
    );
}

export default Button;
